const leftFeatures = [
  {
    icon: "icon-basic-clock",
    title: "Get orders even when you’re offline",
    text: "Your store takes orders and payments automatically - no more replying to every message.",
  },
  {
    icon: "icon-basic-book-pencil",
    title: "Look professional and trustworthy",
    text: "A clean, branded store makes customers feel confident to buy from you.",
  },
  {
    icon: "icon-basic-globe",
    title: "Start getting found on Google",
    text: "Customers searching for your product can now actually find you.",
  },
  {
    icon: "icon-ecommerce-creditcard",
    title: "Collect payments without confusion",
    text: "UPI, cards, and more - all integrated and tracked in one place.",
  },
];

const rightFeatures = [
  {
    icon: "icon-basic-keyboard",
    title: "No tech skills needed",
    text: "You can manage everything easily - we’ll guide you step by step.",
  },
  {
    icon: "icon-basic-headset",
    title: "We understand your business first",
    text: "We suggest what actually works for your type of business.",
  },
  {
    icon: "icon-basic-gear",
    title: "We handle everything for you",
    text: "Setup, design, products, payments - you don’t have to worry about anything.",
  },
  {
    icon: "icon-basic-life-buoy",
    title: "Support even after launch",
    text: "We’re there if you need help - no confusion, no stress.",
  },
];

const SolutionSection = () => {
  return (
    <section id="solution" className="ptb ptb-sm-80 solution-section-spacing">
      <div className="container text-center">
        <h3 className="mt-sm">
          Turn your business into a system that works for you
          <span style={{ color: "#e6ae49" }}>.</span>
        </h3>

        <p className="lead" style={{ maxWidth: "700px", margin: "0 auto" }}>
          No more chaos, missed orders, or manual work. Just a simple system
          that helps you sell, track, and grow.
        </p>
        <div className="spacer-60" />
        <div className="row">
          <div className="wow fadeInLeft col-md-4 d-flex align-content-center flex-wrap">
            {leftFeatures.map((feature) => (
              <div className="features-box-left" key={feature.title}>
                <div className="features-icon-left">
                  <i className={`icon ${feature.icon}`} aria-hidden="true" />
                </div>
                <h5>{feature.title}</h5>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
          <div className="wow fadeIn col-md-4 hidden-sm hidden-xs text-center solution-center-column">
            <img
              style={{ borderRadius: 10 }}
              src="/img/mockup02-desktop.png"
              alt="Key features mockup"
              className="solution-center-mockup"
            />
          </div>
          <div className="wow fadeInRight col-md-4 d-flex align-content-center flex-wrap">
            {rightFeatures.map((feature) => (
              <div className="features-box-left" key={feature.title}>
                <div className="features-icon-left">
                  <i className={`icon ${feature.icon}`} aria-hidden="true" />
                </div>
                <h5>{feature.title}</h5>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
        <p style={{ marginTop: "30px", fontSize: 18, fontWeight: "500" }}>
          This is not just a website.
          <br />
          It’s a system that runs your business smoothly.
        </p>
      </div>
    </section>
  );
};

export default SolutionSection;
